import React from 'react';

/**
 * Reusable stats card component
 * @param {Object} props
 * @param {string} props.icon - Bootstrap icon class (e.g., "bi-people-fill")
 * @param {string} props.iconBg - Background color for icon (e.g., "#dbeafe")
 * @param {string} props.iconColor - Icon color (e.g., "#3b82f6")
 * @param {string} props.badge - Badge text (optional)
 * @param {string} props.badgeClass - Badge CSS classes
 * @param {string|number} props.value - Main stat value
 * @param {string} props.label - Stat label
 * @param {string} props.testId - Test ID for testing
 */
const StatsCard = ({
  icon,
  iconBg,
  iconColor,
  badge,
  badgeClass,
  value,
  label,
  testId
}) => {
  return (
    <div className="col-12 col-md-6 col-xl-3">
      <div className="card border rounded-3">
        <div className="card-body p-4">
          <div className="d-flex align-items-start justify-content-between mb-3">
            <div
              className="d-flex align-items-center justify-content-center rounded-2"
              style={{ width: '48px', height: '48px', backgroundColor: iconBg }}
            >
              <i className={`bi ${icon}`} style={{ fontSize: '20px', color: iconColor }}></i>
            </div>
            {badge && <span className={badgeClass}>{badge}</span>}
          </div>
          <h3 className="h2 fw-bold mb-1" data-testid={testId}>
            {value}
          </h3>
          <p className="text-muted mb-0">{label}</p>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
